import { render } from "./PedidosCambiosNuevo.vue?vue&type=template&id=5d53fc33"
import script from "./PedidosCambiosNuevo.vue?vue&type=script&lang=js"
export * from "./PedidosCambiosNuevo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__